var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVizzhyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 32,
    viewBox: "0 0 160 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 8,
    width: 15,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.854 8.19385H136.105V13.0648H134.854V8.19385ZM122.783 25.163V8.19385H124.034V16.0489H136.105V25.163H134.854V17.2114H124.034V25.163H122.783Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.107 8.19385H122.783V25.163H136.107V8.19385Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 8,
    width: 3,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0694 8.19531H69.8169V25.1632H71.0694V8.19531Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0694 8.19531H69.8169V25.1632H71.0694V8.19531Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 8,
    width: 16,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4431 25.2235H54.5543L61.9881 8.13379H60.6606L54.0218 23.7484L47.4081 8.13379H46.0081L53.4431 25.2235Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9868 8.13379H46.0081V25.2235H61.9868V8.13379Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 8,
    width: 16,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.098 16.5008L144.231 8.19385H145.801L150.801 15.4011L150.098 16.5008ZM151.474 25.163V18.4479L151.428 18.3814L152.878 16.2359L158.473 8.19385H159.971L152.727 18.4241V25.163H151.474Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.969 8.19385H144.231V25.163H159.969V8.19385Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 8,
    width: 14,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6357 25.163H92.9832V24.0269H81.422L92.9832 8.89561V8.19385H80.0457V9.33124H91.197L79.6357 24.4613V25.163Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9832 8.19385H79.6357V25.163H92.9832V8.19385Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 8,
    width: 14,
    height: 18
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.451 25.163H114.799V24.0269H103.238L114.799 8.89561V8.19385H101.862V9.33124H113.013L101.451 24.4613V25.163Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.799 8.19385H101.451V25.163H114.799V8.19385Z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 32
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0462 27.9062C16.0462 30.0165 17.75 31.7276 19.8512 31.7276C21.9525 31.7276 23.6562 30.0165 23.6562 27.9062C23.6562 25.7958 21.9525 24.0847 19.8512 24.0847C17.75 24.0847 16.0462 25.7958 16.0462 27.9062ZM5.83625 16.8574C5.83625 19.5151 7.9825 21.6706 10.6287 21.6706C14.3337 21.6706 14.5375 17.5831 19.7762 17.5831C23.8412 17.5831 24.8337 20.4278 27.0025 20.4278C28.9662 20.4278 30.5575 18.8284 30.5575 16.8574C30.5575 14.8865 28.9662 13.2871 27.0025 13.2871C24.765 13.2871 23.8025 16.0691 19.7762 16.0691C14.6112 16.0691 14.3287 12.043 10.6287 12.043C7.9825 12.043 5.83625 14.1985 5.83625 16.8574ZM28.7837 4.81444C28.7837 6.92476 30.4875 8.63586 32.5887 8.63586C34.69 8.63586 36.3937 6.92476 36.3937 4.81444C36.3937 2.70412 34.69 0.993017 32.5887 0.993017C30.4875 0.993017 28.7837 2.70286 28.7837 4.81444ZM10.7812 4.02605C6.755 4.02605 5.7925 1.2441 3.555 1.2441C1.59125 1.2441 0 2.84221 0 4.81444C0 6.78666 1.59125 8.38478 3.555 8.38478C5.72375 8.38478 6.71625 5.54006 10.7812 5.54006C16.0187 5.54006 16.2225 9.62888 19.9287 9.62888C22.575 9.62888 24.7212 7.47336 24.7212 4.81444C24.7212 2.15551 22.575 0 19.9287 0C16.2287 0 15.9462 4.02605 10.7812 4.02605Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3937 0H0V31.7276H36.3937V0Z",
    fill: "url(#paint0_linear_1_318)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_318",
    x1: -0.01875,
    y1: 15.7841,
    x2: 36.3637,
    y2: 15.7841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF528C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676BB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 31.7276,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizzhyLogo);
export default __webpack_public_path__ + "static/media/vizzhyLogo.ce8468af1848f717cffe8610ce04208d.svg";
export { ForwardRef as ReactComponent };